export default __webpack_public_path__ + "static/media/img5.3a4f6dad.png";